import { render, staticRenderFns } from "./fleet-events.vue?vue&type=template&id=604dee22&"
import script from "./fleet-events.vue?vue&type=script&lang=js&"
export * from "./fleet-events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports